import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxActivityViewComponent } from '@go-modules/components/activity-view/activity-view.component';
import { FilterViewLayoutModule } from '@go-modules/components/filter-view-layout/filter-view-layout.module';
import { SessionSearchModule } from '@go-modules/components/activity-view/session-search/session-search.module';
import { SessionTableModule } from '@go-modules/components/activity-view/session-table/session-table.module';
import { SessionGridModule } from '@go-modules/components/activity-view/session-grid/session-grid.module';
import { SessionListSearchResultInfoModule } from '@go-modules/components/activity-view/session-list-search-result-info/session-list-search-result-info.module';
import { SessionZeroStateModule } from '@go-modules/components/activity-view/session-zero-state/session-zero-state.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { FeedbackHoldModule } from '../feedback-hold/feedback-hold.module';
import { DataSourceZeroStateModule } from '@go-modules/components/data-source-zero-state/data-source-zero-state.module';
import { ActivityContextMenuModule } from '@go-modules/components/activity-view/activity-context-menu/activity-context-menu.module';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { ActivityInstructionsDialogModule } from '../dialogs/activity-Instructions-dialog/activity-instructions-dialog.module';
import { LoadingModule } from '@go-modules/components/loading/loading.module';
import { ActivityTaskPaneComponent } from '@go-modules/components/activity-task-pane/activity-task-pane.component';
import { NgxBannerComponent } from '../ngx-banner/ngx-banner.component';
import { ActivityTaskOverviewComponent } from '../activity-task-overview/activity-task-overview.component';
import { PillToggleComponent } from '../overview-preview-toggle/pill-toggle.component';
import { ActivityNavigationComponent } from '../activity-navigation/activity-navigation.component';
import { ToggleGridListViewComponent } from '../toggle-grid-list-view/toggle-grid-list-view.component';
import { DisabledInteractiveDirective } from '@go-modules/directives/disabled-interactive';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		FormsModule,
		FilterViewLayoutModule,
		SessionSearchModule,
		SessionTableModule,
		TranslateModule,
		SessionGridModule,
		GoMaterialModule,
		GoSelectModule,
		SessionListSearchResultInfoModule,
		SessionZeroStateModule,
		ReactiveFormsModule,
		NgxZeroStateModule,
		FeedbackHoldModule,
		DataSourceZeroStateModule,
		MenuModule,
		ActivityContextMenuModule,
		ActivityInstructionsDialogModule,
		LoadingModule,
		ActivityTaskPaneComponent,
		PillToggleComponent,
		NgxBannerComponent,
		ActivityTaskOverviewComponent,
		ActivityNavigationComponent,
		ToggleGridListViewComponent,
		DisabledInteractiveDirective
	],
	declarations: [
		NgxActivityViewComponent
	],
	exports: [
		NgxActivityViewComponent
	]
})
export class NgxActivityViewModule {}
